// 左辺に右辺を代入！！！！右辺が上位！
// マダイン・サーレハ[3]＝ザフラーン[4]
// マダイン・サーレハ[7]＝ムハンマド[1]
// マスマク城[2]＝ムハンマド[3]
// マスマク城[6]=サウジアラムコ[1]
// ジェッダ[0]=サウジアラムコ[2]
// ムスリム[0]=ムハンマド[0]
// ムスリム[3]=サウジアラムコ[5]
// コーラン[0]=サウジアラムコ[6]
// ジェッダ[2]=ミナレット[3]
// メディナ[3]=ミナレット[1]
// メディナ[0]=メッカ[0]
// カアバ[0]=メッカ[2]


import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Col, Container, Form, Image, InputGroup, Modal, Row } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import { useCookies } from "react-cookie";
import "../general.css";
import "./crossword.css";
import CommentaryModal from './commentary';
import AllAns from "./cw_ans.json";

const CrossWord = ({ en }) => {
  const [cookies, setCookie, removeCookie] = useCookies();


  const inputRefs = useRef([]);
  const handleInputChange = (index, e, id, n) => {
    handlerChange(e, id, n);
    if (e.target.value.length === 1 && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };


  const [crossWW, setCrossWW] = useState({ "ザフラーン": ["", "", "", "", ""], "マスマク城": ["", "", "", "", "", "", ""], "マダインサーレハ": ["", "", "", "", "", "", "", ""], "ムハンマド": ["", "", "", "", ""], "ムスリム": ["", "", "", ""], "コーラン": ["", "", "", ""], "サウジアラムコ": ["", "", "", "", "", "", ""], "ミナレット": ["", "", "", "", ""], "ジェッダ": ["", "", "", ""], "メディナ": ["", "", "", ""], "メッカ": ["", "", ""], "カアバ": ["", "", ""] });
  useEffect(() => {
    if (cookies.crossWW) {
      setCrossWW(cookies.crossWW);
    } else {
      setCookie("crossWW", crossWW, { maxAge: 2592000 });
    }
  }, []
  );

  // 内容が更新されたとき
  const handlerChange = (e, id, n) => {
    let ans = crossWW;
    let text = e.target.value;
    ans[id][n] = text;
    setCrossWW(ans);
    setCookie("crossWW", ans, { maxAge: 2592000 });
    checkClaer(ans);
    // nextfeild(e);
  };


  const checkClaer = (ans) => {
    const ansList = [["ミナレット", 0], ["ムスリム", 1], ["ザフラーン", "0"], ["サウジアラムコ", 5], ["ムハンマド", 0], ["マダインサーレハ", 2], ["マスマク城", 1], ["コーラン", 3]];
    const ansListHira = ["み", "す", "ざ", "む", "む", "い", "す", "ん"];
    let cnt = 0;
    for (let i = 0; i < 8; i++) {
      if (ans[ansList[i][0]][ansList[i][1]] === ansListHira[i] || ans[ansList[i][0]][ansList[i][1]] === ansList[i][0][ansList[i][1]]) { cnt++ }
    }
    if (cnt === 8) {
      if (checkAllClear(ans)) { // 完全クリア
        setCookie("allClear", true, { maxAge: 2592000 });
      }
      // 少なくともアラビア語クリア
      setCookie("dicClear", true, { maxAge: 2592000 });
    } else {
      setCookie("dicClear", false, { maxAge: 2592000 });
    }

  }


  const checkAllClear = (ans) => {
    for (let key in AllAns.hira) {
      let l = AllAns.hira[key].length;
      for (let i = 0; i < l; i++) {
        if (AllAns.hira[key][i] === ans[key][i] || AllAns.kata[key][i] === ans[key][i]) {

        } else {
          return false;
        }
      }
    }
    return true;
  }

  // モーダル処理
  const [modal, setModal] = useState(false);
  // 選択中のカギ
  const [selectKey, setSelectKey] = useState("00");
  // カギの画像が押されたら
  const clickKey = (key) => {
    setSelectKey(key);
    setModal(true);
  }
  // モーダルを閉じる処理
  const closeModal = () => {
    setModal(false);
  }

  return (
    <>
      {en ? (
        <>
          <p>Tapping cell to input letter!</p>
          <small>We're sorry, but <b>please input Japanese letter</b>.<br />You <b>cannot</b> input symbol, kanji, other language letter, and number.</small>
        </>
      ) : (
        <>
          <p>マスをタップして文字を入力しよう！</p>
          <small>マスには <b>ひらがな</b> を入れてくれ。<br />記号や漢字、英数字は入れるなよ。</small>
        </>
      )}
      <div className='position-relative mt-2'>
        <Image className='' src='/img/crossword.png' width="252px" height="504px" />
        <table className='crossword fw-bold position-absolute top-50 start-50 translate-middle'>
          <tbody>
            <tr>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ザフラーン[2]} onChange={(e) => handlerChange(e, "ザフラーン", 2)} tabIndex={3} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ザフラーン[1]} onChange={(e) => handlerChange(e, "ザフラーン", 1)} tabIndex={2} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ザフラーン[0]} onChange={(e) => handlerChange(e, "ザフラーン", 0)} tabIndex={1} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
            </tr>
            <tr>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ザフラーン[3]} onChange={(e) => handlerChange(e, "ザフラーン", 3)} tabIndex={4} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
            </tr>
            <tr>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.マダインサーレハ[2]} onChange={(e) => handlerChange(e, "マダインサーレハ", 2)} tabIndex={27} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ザフラーン[4]} onChange={(e) => handlerChange(e, "ザフラーン", 4)} tabIndex={5} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.マダインサーレハ[4]} onChange={(e) => handlerChange(e, "マダインサーレハ", 4)} tabIndex={28} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.マダインサーレハ[5]} onChange={(e) => handlerChange(e, "マダインサーレハ", 5)} tabIndex={29} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.マスマク城[0]} onChange={(e) => handlerChange(e, "マスマク城", 0)} tabIndex={6} /></td>
              <td className=' crossword'></td>
            </tr>
            <tr>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.マダインサーレハ[1]} onChange={(e) => handlerChange(e, "マダインサーレハ", 1)} tabIndex={26} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.マダインサーレハ[6]} onChange={(e) => handlerChange(e, "マダインサーレハ", 6)} tabIndex={30} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.マスマク城[1]} onChange={(e) => handlerChange(e, "マスマク城", 1)} tabIndex={7} /></td>
              <td className=' crossword'></td>
            </tr>
            <tr>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.マダインサーレハ[0]} onChange={(e) => handlerChange(e, "マダインサーレハ", 0)} tabIndex={25} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ムハンマド[0]} onChange={(e) => handlerChange(e, "ムハンマド", 0)} tabIndex={13} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.マダインサーレハ[7]} onChange={(e) => handlerChange(e, "マダインサーレハ", 7)} tabIndex={14} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ムハンマド[2]} onChange={(e) => handlerChange(e, "ムハンマド", 2)} tabIndex={15} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ムハンマド[3]} onChange={(e) => handlerChange(e, "ムハンマド", 3)} tabIndex={8} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ムハンマド[4]} onChange={(e) => handlerChange(e, "ムハンマド", 4)} tabIndex={16} /></td>
            </tr>
            <tr>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ムスリム[1]} onChange={(e) => handlerChange(e, "ムスリム", 1)} tabIndex={17} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.マスマク城[3]} onChange={(e) => handlerChange(e, "マスマク城", 3)} tabIndex={9} /></td>
              <td className=' crossword'></td>
            </tr>
            <tr>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ムスリム[2]} onChange={(e) => handlerChange(e, "ムスリム", 2)} tabIndex={18} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.マスマク城[4]} onChange={(e) => handlerChange(e, "マスマク城", 4)} tabIndex={10} /></td>
              <td className=' crossword'></td>
            </tr>
            <tr>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.サウジアラムコ[6]} onChange={(e) => handlerChange(e, "サウジアラムコ", 6)} tabIndex={24} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.サウジアラムコ[5]} onChange={(e) => handlerChange(e, "サウジアラムコ", 5)} tabIndex={19} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.サウジアラムコ[4]} onChange={(e) => handlerChange(e, "サウジアラムコ", 4)} tabIndex={23} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.マスマク城[5]} onChange={(e) => handlerChange(e, "マスマク城", 5)} tabIndex={11} /></td>
              <td className=' crossword'></td>
            </tr>
            <tr>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.コーラン[2]} onChange={(e) => handlerChange(e, "コーラン", 2)} tabIndex={37} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.コーラン[1]} onChange={(e) => handlerChange(e, "コーラン", 1)} tabIndex={36} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.サウジアラムコ[3]} onChange={(e) => handlerChange(e, "サウジアラムコ", 3)} tabIndex={22} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.サウジアラムコ[2]} onChange={(e) => handlerChange(e, "サウジアラムコ", 2)} tabIndex={21} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.サウジアラムコ[1]} onChange={(e) => handlerChange(e, "サウジアラムコ", 1)} tabIndex={12} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.サウジアラムコ[0]} onChange={(e) => handlerChange(e, "サウジアラムコ", 0)} tabIndex={20} /></td>
            </tr>
            <tr>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.コーラン[3]} onChange={(e) => handlerChange(e, "コーラン", 3)} tabIndex={38} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ジェッダ[1]} onChange={(e) => handlerChange(e, "ジェッダ", 1)} tabIndex={44} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
            </tr>
            <tr>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ミナレット[0]} onChange={(e) => handlerChange(e, "ミナレット", 0)} tabIndex={31} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ミナレット[1]} onChange={(e) => handlerChange(e, "ミナレット", 1)} tabIndex={32} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ミナレット[2]} onChange={(e) => handlerChange(e, "ミナレット", 2)} tabIndex={33} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ミナレット[3]} onChange={(e) => handlerChange(e, "ミナレット", 3)} tabIndex={34} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ミナレット[4]} onChange={(e) => handlerChange(e, "ミナレット", 4)} tabIndex={35} /></td>
              <td className=' crossword'></td>
            </tr>
            <tr>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.カアバ[2]} onChange={(e) => handlerChange(e, "カアバ", 2)} tabIndex={47} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.メディナ[2]} onChange={(e) => handlerChange(e, "メディナ", 2)} tabIndex={43} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.ジェッダ[3]} onChange={(e) => handlerChange(e, "ジェッダ", 3)} tabIndex={45} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
            </tr>
            <tr>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.カアバ[1]} onChange={(e) => handlerChange(e, "カアバ", 1)} tabIndex={46} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.メディナ[1]} onChange={(e) => handlerChange(e, "メディナ", 1)} tabIndex={42} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
            </tr>
            <tr>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.メッカ[2]} onChange={(e) => handlerChange(e, "メッカ", 2)} tabIndex={41} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.メッカ[1]} onChange={(e) => handlerChange(e, "メッカ", 1)} tabIndex={40} /></td>
              <td className=' crossword'><input type='text' className='crossword' maxLength={1} value={crossWW.メッカ[0]} onChange={(e) => handlerChange(e, "メッカ", 0)} tabIndex={39} /></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
              <td className=' crossword'></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className='mt-3'>
        <hr />
        <h5 className='text-start' style={{ color: "#00a" }}>{en ? "BLUE KEY" : "青色のカギ"}</h5>
        <div className='text-start'>
          <small>{en ? "Tapping these pictures to check explanation if you have password." : "※写真をタップすると説明が読めるぞ"}</small>
        </div>
        <Row className='mt-3'>
          <Col sx={4} className='m-0 p-0'><h5>①</h5><div className='crossword_clue' style={{ backgroundImage: "url('/img/Q/b1.webp')" }} onClick={() => clickKey("b1")}></div></Col>
          <Col sx={4} className='m-0 p-0'><h5>②</h5><div className='crossword_clue' style={{ backgroundImage: "url('/img/Q/b2.webp')" }} onClick={() => clickKey("b2")}></div></Col>
          <Col sx={4} className='m-0 p-0'><h5>③</h5><div className='crossword_clue' style={{ backgroundImage: "url('/img/Q/b3.webp')" }} onClick={() => clickKey("b3")}></div></Col>
        </Row>
        <Row className='mt-3'>
          <Col sx={4} className='m-0 p-0'><h5>④</h5><div className='crossword_clue' style={{ backgroundImage: "url('/img/Q/b4.webp')" }} onClick={() => clickKey("b4")}></div></Col>
          <Col sx={4} className='m-0 p-0'><h5>⑤</h5><div className='crossword_clue' style={{ backgroundImage: "url('/img/Q/b5.webp')" }} onClick={() => clickKey("b5")}></div></Col>
          <Col sx={4} className='m-0 p-0'></Col>
        </Row>
        {/* <Row className='mt-3'>
        </Row> */}
        <hr />
        <h5 className='text-start' style={{ color: "#f66" }}>{en ? "RED KEY" : "赤色のカギ"}</h5>
        <div className='text-start'>
          <small>{en ? "Tapping these pictures to check explanation if you have password." : "※写真をタップすると説明が読めるぞ"}</small>
        </div>    <Row className='mt-3'>
          <Col sx={4} className='m-0 p-0'><h5>①</h5><div className='crossword_clue' style={{ backgroundImage: "url('/img/Q/r1.webp')" }} onClick={() => clickKey("r1")}></div></Col>
          <Col sx={4} className='m-0 p-0'><h5>②</h5><div className='crossword_clue' style={{ backgroundImage: "url('/img/Q/r2.webp')" }} onClick={() => clickKey("r2")}></div></Col>
          <Col sx={4} className='m-0 p-0'><h5>③</h5><div className='crossword_clue' style={{ backgroundImage: "url('/img/Q/r3.webp')" }} onClick={() => clickKey("r3")}></div></Col>
        </Row>
        <Row className='mt-3'>
          <Col sx={4} className='m-0 p-0'><h5>④</h5><div className='crossword_clue' style={{ backgroundImage: "url('/img/Q/r4.webp')" }} onClick={() => clickKey("r4")}></div></Col>
          <Col sx={4} className='m-0 p-0'><h5>⑤</h5><div className='crossword_clue' style={{ backgroundImage: "url('/img/Q/r5.webp')" }} onClick={() => clickKey("r5")}></div></Col>
          <Col sx={4} className='m-0 p-0'><h5>⑥</h5><div className='crossword_clue' style={{ backgroundImage: "url('/img/Q/r6.webp')" }} onClick={() => clickKey("r6")}></div></Col>
        </Row>
        <Row className='mt-3'>
          <Col sx={4} className='m-0 p-0'><h5>⑦</h5><div className='crossword_clue' style={{ backgroundImage: "url('/img/Q/r7.webp')" }} onClick={() => clickKey("r7")}></div></Col>
          <Col sx={4} className='m-0 p-0'></Col>
          <Col sx={4} className='m-0 p-0'></Col>
        </Row>
      </div>

      <CommentaryModal en={en} modal={modal} closeModal={closeModal} selectKey={selectKey} />

    </>
  )
}

export default CrossWord;
